module.exports = __webpack_public_path__ + "/login_ui/img/cf-3eab92eeee62b1e1bbaef9b8fdbd3ab3.svg";